
$('[data-action="menu-toggle"]').click(function(){
	$('.hamburger').toggleClass('is-active');
	$('body').toggleClass('menu-open');
});

$('.header').find('.has-submenu > a,.has-submenu > span').click(function(e){
	e.preventDefault();
	var $this = $(this);
	$this.closest('.menu').find('.is-open').removeClass('is-open');
	$(document).one('click', function(){
		$this.next().removeClass('is-open');
	});
	$this.next().toggleClass('is-open');
	return false;
});
$('#mobile-main-menu').find('.has-submenu > a').click(function(e) {
	e.preventDefault();
	var $this = $(this);

	$this.next().toggleClass('d-none');
	return false;
});

